import { render, staticRenderFns } from "./SysNcTemplateTableDefault.vue?vue&type=template&id=539db952&"
import script from "./SysNcTemplateTableDefault.vue?vue&type=script&lang=js&"
export * from "./SysNcTemplateTableDefault.vue?vue&type=script&lang=js&"
import style0 from "./SysNcTemplateTableDefault.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports